import { Box, IconButton, Stack, Typography, useTheme } from '@mui/material';
import TopicCard from './TopicCard';
import { CheckCircle, Close } from '@mui/icons-material';
import { useAppSelector } from 'src/app/hooks';
import { useState } from 'react';
import ChatInput from './ChatInput';
import { TChatMode } from 'src/features/chatNow';

export default function EmptyChat({
  handleClickTopic,
  handleSendBooleanQueryMessage,
  handleSendChatNowMessage,
  chatInputValue,
  isLoading,
  sendingLoading,
  handleChange,
  handleSendMessage
}: {
  handleClickTopic: (topic: TChatMode) => void;
  handleSendBooleanQueryMessage: (content: string) => Promise<void>;
  handleSendChatNowMessage: (content: string) => Promise<void>;
  chatInputValue: string;
  isLoading: boolean;
  sendingLoading: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSendMessage: (content: string) => Promise<void>;
}) {
  const theme = useTheme();
  const [openTips, setOpenTips] = useState<boolean>(true);
  const { position } = useAppSelector(
    (state) => state.storeAIAssistantPosition
  );

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        gap={position === 'window' ? 1 : 2}
        sx={{ padding: position === 'window' ? 2 : 1 }}
        height="100%"
        width={position === 'full' ? '50%' : '100%'}
      >
        <Stack height="100%" justifyContent="center">
          <Typography
            variant="body2"
            fontSize={position === 'window' ? 14 : 20}
            textAlign="center"
            color={theme.colors.primary.main}
          >
            How may I assist you?{' '}
          </Typography>
        </Stack>
        <Stack gap={1} height="100%" width="100%" justifyContent="center">
          <TopicCard
            description={`Create an Industry Focused Boolean Query`}
            onClick={() => {
              handleClickTopic('booleanQuery');
              handleSendBooleanQueryMessage(
                `Create an Industry Focused Boolean Query`
              );
            }}
          />
          <TopicCard
            description="What social media trends have emerged in the past two weeks?"
            onClick={() => {
              handleClickTopic('chatNow');
              handleSendChatNowMessage(
                `What social media trends have emerged in the past two weeks?`
              );
            }}
          />
          <ChatInput
            chatInputValue={chatInputValue}
            handleChange={handleChange}
            handleSendMessage={handleSendMessage}
            isLoading={isLoading}
            sendingLoading={sendingLoading}
          />
          {openTips && (
            <Stack
              sx={{
                borderRadius: '8px',
                backgroundColor: theme.colors.success.lighter,
                padding: 2
              }}
              width="100%"
              gap={1}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                width="100%"
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <CheckCircle htmlColor={theme.colors.success.light} />
                  <Typography>Tips</Typography>
                </Stack>
                <IconButton
                  size="small"
                  onClick={() => setOpenTips(false)}
                  sx={{ width: 24, height: 24 }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </Stack>
              <Typography fontSize="12px">
                Type “Create Boolean Query” for advanced setup, or enter a
                keyword or question.
              </Typography>
            </Stack>
          )}
        </Stack>
      </Box>
    </>
  );
}
